import { makeAutoObservable, onBecomeObserved } from "mobx"
import { AxiosResponse } from "axios"

import {
  APIDataWithPagination,
  APIPagination,
  APIResponse,
  catchErrors,
  currenciesApi,
  whitelistAddressesApi,
} from "@src/shared/api"
import { InlineObject17 } from "@src/shared/api/generated"
import { capitalizeFirstLetter } from "../../pages/settingsWhitelist/capitalizeFirstLetter"

export interface WhitelistAddress {
  address: string
  created_at: Date
  id: string
  name: string
  network: string
  status: "confirmed" | "pending"
  updated_at: Date
}

export type CreateWhiteListAddressReq = {
  address: string
  name: string
  network: string
}

class WhitelistStore {
  private _currencies?: Array<any>
  private _whitelist?: Array<WhitelistAddress>

  createWhitelistAddress = (identity: CreateWhiteListAddressReq) =>
    whitelistAddressesApi
      .createWhitelistAddress(identity)
      .then(() => this.loadWhitelist())

  deleteWhitelistAddress = (id: string) =>
    whitelistAddressesApi
      .deleteWhitelistAddress(id)
      .then(() => this.loadWhitelist())

  getWhiteListId = (id: string) => (this.whiteListId = id)

  isLoading = false

  loadCurrencies = async () => {
    this.isLoading = true

    return currenciesApi
      .getCurrencies()
      .then((response) => {
        const { data } = response as AxiosResponse<APIResponse>

        this._currencies = data.data
      })
      .catch(catchErrors)
      .finally(() => {
        this.isLoading = false
      })
  }

  loadWhitelist = async (offset = 0) => {
    this.isLoading = true

    return whitelistAddressesApi
      .listWhitelistAddresses(undefined, offset, this.pageSize)
      .then((response) => {
        const { data } = response as AxiosResponse<
          APIResponse<APIDataWithPagination<any, any>>
        >

        this._whitelist = data.data!.addresses

        this.total = data.data!.pagination.total
      })
      .catch(catchErrors)
      .finally(() => {
        this.isLoading = false
      })
  }
  pageSize = 25
  total?: APIPagination["total"]

  whiteListId: string = ""

  constructor() {
    makeAutoObservable(this)

    onBecomeObserved(this, "_whitelist", this.loadWhitelist)

    onBecomeObserved(this, "_currencies", this.loadCurrencies)
  }

  get currencies() {
    const uniqueAddresses = [
      ...new Set(this._currencies?.map((item) => item.network)),
    ]

    return (
      uniqueAddresses?.map((item) => ({
        label: capitalizeFirstLetter(item),
        value: item,
      })) || []
    )
  }

  get whitelist() {
    return this._whitelist?.map((item) => ({ key: item.id, ...item })) || []
  }
}

export const whitelistStore = new WhitelistStore()
